import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useLanguageData } from '../hooks/useLanguageData';
import { LanguageContext } from '../contexts/LanguageContext';

const Seo = () => {
	const common = useLanguageData('common');
	const { lang } = useContext(LanguageContext);

	return (
		<>
			<Helmet
				htmlAttributes={{
					lang,
				}}
			>
				<title>{`Soft Ai`}</title>
				<meta property='description' content={common?.description} />
				<meta property='og:title' content='Soft Ai' />
				<meta property='og:description' content={common?.description} />
			</Helmet>
		</>
	);
};

export default Seo;
